import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

const initialState: any = {
  subMenuIndex: true,
  showSubMenu: false,
};

export const subMenuIndexSlices = createSlice({
  name: 'subMenuIndexSlices',
  initialState,
  reducers: {
    updateSubMenuIndex: (state, action) => {
      state.subMenuIndex = action.payload;
    },
    updateShowSubMenu: (state, action) => {
      state.showSubMenu = action.payload;
    },
  },
});

export const { updateSubMenuIndex, updateShowSubMenu } = subMenuIndexSlices.actions;

export const subMenuIndexState = (state: RootState) => state.subMenu.subMenuIndex;
export const subShowSubMenuState = (state: RootState) => state.subMenu.showSubMenu;

export default subMenuIndexSlices.reducer;
